import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Container = styled.div`
  display: flex;

  width: 100%;
  padding: 1rem 0;

  border-left: 0.1rem solid ${pickColor('silver')};
  border-bottom: 0.1rem solid ${pickColor('silver')};
`;

const ImageContainer = styled.div`
  width: 20rem;
`;

const Wrapper = styled.div`
  flex: 1;
`;

const Info = styled.div`
  display: flex;
  gap: 1.5rem;

  padding-bottom: 1rem;

  border-bottom: 0.1rem dashed ${pickColor('silver')};
`;

const InfoText = styled(Headline)`
  flex-basis: 17rem;
`;

const Inputs = styled.div`
  display: flex;
  gap: 1.5rem;

  padding-top: 1rem;

  & > {
    flex-basis: 25%;
  }
`;

export { Container, ImageContainer, Info, InfoText, Inputs, Wrapper };
